<template>
  <div v-if="candidates.length" class="copilot-clarification">
    <p class="copilot-clarification__question">
      {{ question || $t('copilot.chooseTable') }}
    </p>
    <div class="copilot-clarification__options">
      <button
        v-for="candidate in candidates"
        :key="candidate.candidate_id"
        type="button"
        class="copilot-clarification__option"
        :disabled="disabled"
        @click="$emit('choose', candidate)"
      >
        <span class="copilot-clarification__label">
          {{ candidate.menu_label || candidate.table_name }}
        </span>
        <span
          v-if="candidate.solution_label"
          class="copilot-clarification__meta"
        >
          {{ candidate.solution_label }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopilotClarification',
  props: {
    question: {
      type: String,
      default: '',
    },
    candidates: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.copilot-clarification {
  margin-bottom: 8px;
}

.copilot-clarification__question {
  margin: 0 0 8px;
  font-size: 13px;
  color: #374151;
}

.copilot-clarification__options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.copilot-clarification__option {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 8px 10px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  background: #f9fafb;
  cursor: pointer;
}

.copilot-clarification__option:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.copilot-clarification__label {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.copilot-clarification__meta {
  font-size: 12px;
  color: #6b7280;
}
</style>
